<template>
    <div>
        <div class="assess-admin-class-addWrapper" >
            <div class="assess-admin-class-addSection" >
                <span>受理部门</span>
                <span @click="departmentClick" >{{departmentSelected}}<i class="iconfont icon-more " ></i></span>
            </div>
            <div class="assess-admin-class-addSection" >
                <span>受理人员</span>
                <span @click="personClick" >{{personSelected}}<i class="iconfont icon-more " ></i></span>
            </div>
        </div>
        <div class="assess-student-msg-input" >
            <textarea placeholder="请输入您的留言" v-model.trim="msgDeal" ></textarea>
        </div>
        <div class="assess-student-msg-send" >
            <button @click="addNewMsg" >发送</button>
        </div>

        <!-- 受理部门选择组件 -->
        <mt-popup v-model="popupVisible1" position="bottom" class="studentStyle" >
            <mt-picker :slots="getDepartmentData" valueKey="codeName" ref="picker" :show-toolbar="true" ></mt-picker>
            <mt-button @click="handleDepartmentConfirm" type="default" class="sure">确认</mt-button>
        </mt-popup>

        <!-- 受理人员选择组件 -->
        <mt-popup v-model="popupVisible2" position="bottom" class="studentStyle" >
            <mt-picker :slots="getPersonData" valueKey="teaName" ref="picker1" :show-toolbar="true" ></mt-picker>
            <mt-button @click="handlePersonConfirm" type="default" class="sure">确认</mt-button>
        </mt-popup>

        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import { getUserInfo } from '@/service/user-service.js'
import Bottom from '../bottom.vue'
import { Toast } from 'mint-ui';
export default {
    data() {
        return {
            popupVisible: false,
            popupVisible1: false,
            popupVisible2: false,
            userInfo: {},
            timeInfo: {},
            departmentList: [],           //受理部门容器   
            personList: [],               //受理人员容器
            departmentSelected: "请选择",
            personSelected: "请选择",
            isShowDepartment: false,
            isShowPerson: false,
            msgDeal: '',
            personId: '',                //教师id
            roleId: '',                   //角色id
            currentDepartment: {},
            currentPerson: {}
        }
    },
    components: { Bottom },
    mounted() {
        this.$nextTick( () => {
            getUserInfo().then((user) => {
                this.userInfo = user.user;
                this.timeInfo = user.nowYearAndTermAndMonth;
                this.currentUserId = user.userId;
            });
        });
    },
    methods: {
        handleDepartmentConfirm() {
            this.currentDepartment = this.$refs.picker.getValues()[0];
            this.departmentSelected = this.currentDepartment.codeName;
            this.roleId = this.currentDepartment.codeValue;
            this.personSelected = '请选择';
            this.personId = '';
            this.popupVisible1 = false
        },
        handlePersonConfirm() {
            this.currentPerson = this.$refs.picker1.getValues()[0];
            this.personSelected = this.currentPerson.teaName;
            this.personId = this.currentPerson.teacherId;
            this.popupVisible2 = false
        },
        departmentClick() {
            this.popupVisible1 = true;
        },
        personClick() {
            if(this.roleId == '') {
                Toast('请先选择受理部门');
                return;
            }
            if(!this.personList.length) {
                Toast('该部门下没有人员');
                return;
            }
            this.popupVisible2 = true;
        },
        addNewMsg() {
            if(this.roleId == '' || this.personId == '' || this.msgDeal == '' ) {
                Toast('受理部门/受理人员/留言内容均为必填哦~');
                return;
            }
            this.$http.get('/api/mobile/devel/comment/addLeaveMessage', {
                params: {
                    changeTeacherId: this.personId,
                    schoolYear: this.timeInfo.year,
                    eduPeriod: this.timeInfo.term,
                    schoolId: this.userInfo.schoolId,
                    userId: this.currentUserId,
                    role: this.roleId,
                    content: this.msgDeal,
                    type: 1
                }
            }).then(res => {
                if(res.data.code == 0) {
                    this.$router.replace({name:'Assess-student-msg'});
                }
            })
        },
    },
    computed: {
        getDepartmentData: function() {
            let list = [];
            let studentList = [{
                values: list
            }];
            if(this.userInfo.schoolId) {
                this.$http.get('/api/mobile/devel/sys/getListRole', {
                    params: {
                        schoolId: this.userInfo.schoolId
                    }
                }).then( res => {
                    if(res.data.code == 0) {
                        res.data.data.forEach(item => {
                            list.push(item);
                        });
                    }
                })
            }
            return studentList;
        },
        getPersonData: function() {
            let list = [];
            let studentList = [{
                values: list
            }];
            if(this.roleId) {
                this.$http.get('/api/mobile/devel/sys/getRoleTeach', {
                    params: {
                        roleId: this.roleId
                    }
                }).then(res => {
                    if(res.data.code == 0) {
                        this.personList = res.data.data;
                        res.data.data.forEach(item => {
                            list.push(item);
                        })
                    }
                });
            }
            return studentList;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/assessment/assess-student-msg-add.vue